import api from "./api";

class TipoOperazioniManager {

    tipoOperazioni(config?: any) {
        return api.get(`/tipo_operazioni`, config)
    }

    tipoOperazione(id:number|string) {
        return api.get(`/tipo_operazioni/${id}`)
    }

    list=this.tipoOperazioni
    retrieve=this.tipoOperazione
}

const tipoOperazioniManager = new TipoOperazioniManager()

export default tipoOperazioniManager
